import moment from 'moment';

import ErrorIcon from '@common/assets/icons/chat/error.svg?react';
import ReadedIcon from '@common/assets/icons/chat/readed.svg?react';
import SendingIcon from '@common/assets/icons/chat/sending.svg?react';
import SentIcon from '@common/assets/icons/chat/sent.svg?react';

import styles from './ChatMessage.module.scss';

export type ChatMessageProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  type: 'my' | 'friend';
  status: 'readed' | 'sended' | 'failed' | 'sending';
  date: string;
  text: string;
};

export const ChatMessage: React.FC<ChatMessageProps> = ({
  type,
  status,
  date,
  text,
}) => {
  const time =
    moment().diff(moment(date), 'days') >= 7
      ? moment(date).format('DD MMM HH:mm')
      : moment(date).format('HH:mm');

  let statusIcon: React.ReactNode = null;
  let statusTestId: string | null = null;

  if (status === 'readed') {
    statusIcon = <ReadedIcon />;
    statusTestId = 'chat-message-status-readed';
  }

  if (status === 'sended') {
    statusIcon = <SentIcon />;
    statusTestId = 'chat-message-status-sended';
  }

  if (status === 'failed') {
    statusIcon = <ErrorIcon />;
    statusTestId = 'chat-message-status-failed';
  }

  if (status === 'sending') {
    statusIcon = <SendingIcon />;
    statusTestId = 'chat-message-status-sending';
  }

  return (
    <div className={styles.chatMessage} data-type={type}>
      <p className={styles.text} data-sentry-mask>
        {text}
        <span className={styles.time} data-test-id="chat-message-time">
          <span className={styles.inner}>
            {time}
            {type === 'my' && statusIcon && statusTestId && (
              <span className={styles.status} data-test-id={statusTestId}>
                {statusIcon}
              </span>
            )}
          </span>
        </span>
      </p>
    </div>
  );
};
